<template>
  <v-select 
    :class="options.css_classes" 
    :clearable="false" 
    :options="options.source" 
    :multiple="options.allow_multiple" 
    :placeholder="'- Please select -'" 
    @input="setActiveValues" 
    class="vf-select"
    transition="">
    <template #open-indicator="{ attributes }">
      <span 
        v-bind="attributes" 
        v-html="$icons.get('caret_down', 'small')">
      </span>
    </template>
  </v-select>
</template>

<script>
import {_} from 'vue-underscore'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default { 
  name: 'DropdownField',
  components: {
    vSelect
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  data () {
    return {
      attributes: {
        ref: 'openIndicator',
        role: 'presentation',
        class: 'vs__open-indicator',
      }
    }
  },
  methods: {
    setActiveValues(val) {
      if (this.options.allow_multiple === true) {

        let values = [];
        _.each(val, function(single_val) {
          values.push(single_val.value)
        })

        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: values
        })
      } else {
        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: val.value
        })
      }
    },
    validate () {
      if (this.options.allow_multiple) {
        return (this.value.length !== 0)
      } else {
        return (this.value !== undefined && this.value != '')
      }
    }
  },
  computed: {
    fieldValue: {
      get() {
        return this.value
      }/* ,
      set(val) {
        
      } */
    }
  }
}
</script>
